export const achievementData = {
    bio : "Here are a few certifications I hold. While I value continuous learning, I place a stronger emphasis on action, results, and a proven track record over certifications.",
    achievements : [
        {
            id : 1,
            title : 'Code:You',
            details : 'Code:You is a 6-month, part-time coding bootcamp for absolute beginners to learn data analytics with python and launch a career in tech.',
            date : 'Aug 20, 2019',
            field : 'Automation',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id : 2,
            title : 'AWS Certification',
            details : 'Learn the fundamentals of AWS Cloud, AWS services, security, architecture, pricing, and support to prepare for the AWS Certified Cloud Practitioner exam.',
            date : 'Aug 20, 2024',
            field : 'Cloud',
            image : 'https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id : 3,
            title : 'Six Sigma White Belt',
            details : 'Trainees become familiar with the basic principles of Lean Six Sigma and the Six Sigma DMAIC (Define, Measure, Analyze, Improve, Control) improvement cycle.',
            date : 'Sept 20, 2025',
            field : 'Quality',
            image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/